var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScNewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 50,
    height: 50,
    rx: 25,
    fill: "#FF7D19"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2588_84515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0897 19.2097L41.0193 27.7831L40.9353 30.4354C40.9353 30.4354 9.88671 31.4721 8.51404 31.0985L9.38246 18.8828L11.9037 19.3778L14.5557 21.8994L21.2603 20.9094L24.0897 19.2097Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7219 26.3316L23.8474 18.5053C23.5579 18.3652 23.2031 18.4493 23.0257 18.7201C22.3534 19.6914 20.878 20.8681 17.6564 21.0456C15.7234 21.1483 13.6971 20.7841 13.4076 20.2798C12.4738 18.4026 10.9051 18.029 9.85922 18.2812C8.75735 18.5427 8.03833 19.4392 8.03833 20.5693V30.777C8.03833 31.2907 8.45854 31.7109 8.97212 31.7109H39.4417C40.7677 31.7109 41.8696 30.9171 42.1217 29.7871C42.2151 29.2921 42.3645 27.583 39.7219 26.3316ZM36.1174 25.9673C36.8178 26.3409 37.6862 26.7985 38.8908 27.3962C39.0215 27.4616 38.9748 27.6577 38.8254 27.6577H25.631C25.5376 27.6577 25.4722 27.5737 25.4909 27.4896C25.8551 25.902 27.2277 24.7439 28.7405 24.7439C29.5996 24.7439 30.2999 24.7346 30.8695 24.7252C33.7083 24.6972 33.7083 24.6972 36.1174 25.9673ZM9.42034 20.5693C9.42034 19.9809 9.75651 19.5887 10.3074 19.5139C11.0358 19.4205 11.9696 19.8968 12.2124 20.7747C12.3618 21.2884 13.0995 21.746 14.2294 22.0355C17.1801 22.792 21.6904 22.269 23.8474 20.1116L23.9221 20.0369L30.3746 23.2029C30.5053 23.2683 30.4587 23.4644 30.3093 23.4644C27.5546 23.4644 24.6785 23.9501 24.2116 27.5363L24.1929 27.6577H16.2744C16.1997 27.6577 16.1436 27.6017 16.1343 27.5363C16.0222 26.042 15.2192 24.6225 13.9212 23.6325C12.6232 22.6426 11.0451 22.2316 9.58842 22.5118C9.50438 22.5305 9.42034 22.4651 9.42034 22.3717V20.5693ZM9.42968 23.8193L9.5324 23.7913C10.4849 23.5205 11.7642 23.7726 12.8007 24.4264C13.9212 25.1361 14.6496 26.2195 14.8643 27.499C14.883 27.583 14.8177 27.6577 14.7243 27.6577H9.43902C9.36431 27.6577 9.29895 27.5923 9.29895 27.5176L9.42968 23.8193ZM40.8798 29.096C40.8798 29.1053 40.7304 30.4221 39.4231 30.4221H9.44835C9.37365 30.4221 9.30829 30.3568 9.30829 30.282V29.0866C9.30829 29.0119 9.37365 28.9465 9.44835 28.9465H40.749C40.8237 28.9465 40.8891 29.0119 40.8798 29.096Z",
    fill: "#251B7D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2588_84515"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white",
    transform: "translate(7.5 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScNewIcon);
export default __webpack_public_path__ + "static/media/sc-new-icon.e696a64c63f2ffb97a3562549e8d8c86.svg";
export { ForwardRef as ReactComponent };